import Female from "../asset/images/genderGroup/female.png";
import Male from "../asset/images/genderGroup/male.png";
import FreeDrinks from "../asset/images/icons/freedrinks.png";
import FreeEntry from "../asset/images/icons/freeentry.png";
import GoOut from "../asset/images/icons/goout.png";
import MeetGuests from "../asset/images/icons/meet_guests.png";
import CallNow from "../asset/images/icons/Chat Now.png";
import Copy from "../asset/images/icons/copy.png";
import Star from "../asset/images/icons/star-24.png";
import ChatCheck from "../asset/images/icons/chatCheck.png";
import ChatCamera from "../asset/images/icons/chatCamera.png";
import ChatTelephone from "../asset/images/icons/chatTelephone.png";
import ChatButton from "../asset/images/icons/ChatButton.png";
import freeDinner from "../asset/images/dinnerIcon.png";
import freeTaxi from "../asset/images/taxiIcon.png";
import preDrink from "../asset/images/pre_drink_icon.png";
import goodyBag from "../asset/images/queue_jump_icon.png";
import WhiteStar from "../asset/images/whiteStar.png";
import UpcomingEvents from "../asset/images/UpcomingEvents.png";
import Location from "../asset/images/Location.png";
import Image from "../asset/images/icons/Image.png";
import World from "../asset/images/icons/world.png";
import Profile from "../asset/images/icons/Profile.png";
import GuestList from "../asset/images/icons/guestlist.png";
import Table from "../asset/images/icons/table.png";
import Money from "../asset/images/icons/money.png"
import Girl from "../asset/images/genderGroup/Girl.png"
import Girl_96x96 from "../asset/images/genderGroup/Girl-96x96.png"
import Boy from "../asset/images/genderGroup/Boy.png"
import Boy_96x96 from "../asset/images/genderGroup/Boy-96x96.png"
import Camera from "../asset/images/icons/CameraIcons/icons-round.png";
import CloseCamera from "../asset/images/icons/CameraIcons/icons-close-window.png"
import SwitchCamera from "../asset/images/icons/CameraIcons/icons-switch-camera.png"
import Send from "../asset/images/icons/send.png"

import User from "../asset/images/icons/user-60.png";
import Mobile from "../asset/images/icons/phone-50.png";
import Email from "../asset/images/icons/mail-50.png"
import Genders from "../asset/images/icons/gender-48.png";

export const iconsImgs = {
  // Gender Icons
  Female: Female,
  Male: Male,
  Girl: Girl,
  Girl_96x96: Girl_96x96,
  Boy: Boy,
  Boy_96x96: Boy_96x96,
  // Club Icons
  FreeDrinks: FreeDrinks,
  FreeEntry: FreeEntry,
  FreeDinner: freeDinner,
  FreeTaxi: freeTaxi,
  PreDrink: preDrink,
  GoodyBag: goodyBag,
  GoOut: GoOut,
  MeetGuests: MeetGuests,
  CallNow: CallNow,
  Copy: Copy,
  TableBooking: Table,
  GuestListBooking: GuestList,
  MinimumSpend: Money,
  // Promoter side/ Offer
  Star: Star,
  WhiteStar: WhiteStar,
  UpcomingEvents: UpcomingEvents,
  Location: Location,
  //Chat
  ChatCheck: ChatCheck,
  ChatCamera: ChatCamera,
  ChatTelephone: ChatTelephone,
  ChatButton: ChatButton,
  Send: Send,
  //User Profile
  Image: Image,
  World: World,
  Profile: Profile,
  //Invited friends details
  User: User,
  Mobile: Mobile,
  Email: Email,
  Genders: Genders,
  //Camera
  Camera: Camera,
  CloseCamera: CloseCamera,
  SwitchCamera: SwitchCamera
};
